import { render } from "./MultiSelectList.vue?vue&type=template&id=15586054&scoped=true"
import script from "./MultiSelectList.vue?vue&type=script&lang=js"
export * from "./MultiSelectList.vue?vue&type=script&lang=js"

import "./MultiSelectList.vue?vue&type=style&index=0&id=15586054&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15586054"]])

export default __exports__